<script lang="ts">
	import translations from "./Awards.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";
	import LinkCard from "./LinkCard.svelte";
	import awardHover from "../assets/images/award.jpeg?webp&h=428&imagetools";
	import arrowLeft from "../../../core/assets/icons/arrowLeft.svg?raw";
	import arrowRight from "../../../core/assets/icons/arrowRight.svg?raw";
	import Icon from "./Icon.svelte";
	import * as Glide from "@glidejs/glide";
	import { disableGlidePerSlideAmount } from "../utils/disableGlidePerSlideAmount.js";
	import type { ActionReturn } from "svelte/action";
	import { querySizeMappings } from "../utils/querySizeMappings.js";

	const translate = getTranslate(translations);

	const awards = [
		{
			header: translate("award1Header"),
			description: translate("award1Description"),
		},
		{
			header: translate("award2Header"),
			description: translate("award2Description"),
		},
		{
			header: translate("award3Header"),
			description: translate("award3Description"),
		},
	];

	function glide(element: HTMLElement, perView: number): ActionReturn {
		const glideOptions = {
			type: "carousel",
			startAt: 0,
			perView,
			focusAt: "center",
			animationDuration: 650,
			animationTimingFunc: "ease-in-out",
			gap: 20,
			keyboard: true,
			rewind: false,
			cloningRatio: 2,
		} satisfies Partial<Glide.Options>;

		// eslint-disable-next-line new-cap
		const glide = new Glide.default(element, { ...glideOptions }).mount();
		glide.on("resize", () => {
			disableGlidePerSlideAmount(glide, element);
		});

		return {
			update(perView): void {
				glide.update({ perView });
				disableGlidePerSlideAmount(glide, element);
			},
			destroy(): void {
				glide.destroy();
			},
		};
	}

	let innerWidth = 0;
</script>

<svelte:window bind:innerWidth />

<section
	use:glide={innerWidth > querySizeMappings.lg ? 3 : 1}
	class="glide container grid grid-cols-1 grid-rows-[auto,1fr,auto] gap-16 py-14 lg:min-h-screen lg:grid-cols-2 lg:grid-rows-[auto,1fr] lg:gap-28"
>
	<h2 class="m-0 text-[2.75rem] font-semibold lg:text-4xl">{translate("awards")}</h2>
	<div
		class="row-start-3 flex justify-center gap-11 lg:col-start-2 lg:row-start-1 lg:justify-end"
		data-glide-el="controls"
	>
		<button aria-label="Posuňte se doleva" class="opacity-20 transition-opacity hover:opacity-100" data-glide-dir="<">
			<Icon icon={arrowLeft} class="h-20" />
		</button>
		<button aria-label="Posuňte se doprava" class="opacity-20 transition-opacity hover:opacity-100" data-glide-dir=">">
			<Icon icon={arrowRight} class="h-20" />
		</button>
	</div>
	<div class="glide__track col-span-full aspect-square w-full lg:aspect-auto" data-glide-el="track">
		<div class="glide__slides h-full w-full">
			{#each awards as award, index}
				<LinkCard
					class="glide__slide !aspect-auto !min-w-[initial] !max-w-[initial] bg-white"
					{index}
					title={award.header.toLocaleUpperCase()}
					sectionName={award.description}
					backgroundImage={awardHover}
					backgroundImageOverlay
					fixedBgOnMobile
					disableAnimation
				/>
			{/each}
		</div>
	</div>
</section>
